import { originEnum } from "../Enums/OriginEnum";

class Origin {
  getOrigin(param) {
    return originEnum[param] || originEnum.default;
  }
}

export default new Origin();
